import { useState, useEffect } from 'react';

/**
 * There can be issues with components not updating their outdated server side
 * generated html. Use this hook to force redraw a page after it has mounted.
 *
 * const redrawKey = useRedrawOnMountKey()
 * ...
 * <Component key={redrawKey} />.
 */
const useRedrawOnMountKey = () => {
  const [key, setKey] = useState(`not-mounted-${String(Math.random()).substr(2)}`);

  useEffect(() => {
    setKey(`mounted-${String(Math.random()).substr(2)}`);
  }, []);

  return key;
};

export default useRedrawOnMountKey;
